// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Column$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as Switch$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/switch/Switch.bs.js";
import * as ConfirmationModal from "../../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";
import * as CustomerApiHandler from "../../state-machine/CustomerApiHandler.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";

var validators = {
  enabled: undefined,
  config_id: undefined
};

function initialFieldsStatuses(_input) {
  return {
          enabled: /* Pristine */0,
          config_id: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            enabled: /* Pristine */0,
            config_id: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, param, param$1) {
  var match_0 = {
    TAG: /* Ok */0,
    _0: input.enabled
  };
  var match_0$1 = {
    TAG: /* Ok */0,
    _0: input.config_id
  };
  var enabledResult = match_0;
  var enabledResult$1;
  if (enabledResult.TAG === /* Ok */0) {
    var config_idResult = match_0$1;
    if (config_idResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                config_id: config_idResult._0,
                enabled: enabledResult._0
              },
              fieldsStatuses: {
                enabled: /* Dirty */{
                  _0: enabledResult,
                  _1: /* Hidden */1
                },
                config_id: /* Dirty */{
                  _0: config_idResult,
                  _1: /* Hidden */1
                }
              },
              collectionsStatuses: undefined
            };
    }
    enabledResult$1 = enabledResult;
  } else {
    enabledResult$1 = enabledResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            enabled: /* Dirty */{
              _0: enabledResult$1,
              _1: /* Hidden */1
            },
            config_id: /* Dirty */{
              _0: match_0$1,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurEnabledField */0 :
                  var result = Formality.validateFieldOnBlurWithoutValidator(state.input.enabled, state.fieldsStatuses.enabled, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  enabled: status,
                                  config_id: init.config_id
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurConfig_idField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.config_id, state.fieldsStatuses.config_id, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  enabled: init.enabled,
                                  config_id: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */2,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */3,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */5);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */4);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateEnabledField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.enabled, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            enabled: status,
                                            config_id: init.config_id
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateConfig_idField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.config_id, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            enabled: init.enabled,
                                            config_id: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                enabled: /* Pristine */0,
                                config_id: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                enabled: /* Pristine */0,
                                config_id: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateEnabled: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnabledField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateConfig_id: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateConfig_idField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurEnabled: (function (param) {
              return Curry._1(dispatch, /* BlurEnabledField */0);
            }),
          blurConfig_id: (function (param) {
              return Curry._1(dispatch, /* BlurConfig_idField */1);
            }),
          enabledResult: Formality.exposeFieldResult(state.fieldsStatuses.enabled),
          config_idResult: Formality.exposeFieldResult(state.fieldsStatuses.config_id),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.enabled || match.config_id) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */4,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function NotificationSettingsCmp(Props) {
  var uuid = Props.uuid;
  var customer_consents = Props.customer_consents;
  var isConsentUpdated = Props.isConsentUpdated;
  var setIsConsentUpdated = Props.setIsConsentUpdated;
  var openSnackbar = Props.openSnackbar;
  var closeCustomerInfoSidebar = Props.closeCustomerInfoSidebar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var consents_input = [];
  var match$1 = React.useState(function () {
        return false;
      });
  var updateCnfModalState = match$1[1];
  var getUpdatedOptionalConsents = function (consents) {
    return $$Array.map((function (consent) {
                  return {
                          consent_config_id: consent.config_id,
                          enabled: !consent.enabled
                        };
                }), consents.filter(function (consent) {
                    return $$Array.exists((function (input) {
                                  if (input.config_id === consent.config_id) {
                                    return input.enabled !== consent.enabled;
                                  } else {
                                    return false;
                                  }
                                }), consents_input);
                  }));
  };
  var getUpdatedConsents = function (param) {
    return $$Array.map((function (consents) {
                    return {
                            message_type: consents.consent_type,
                            channels: getUpdatedOptionalConsents(consents.optional)
                          };
                  }), customer_consents).filter(function (updatedConsent) {
                return updatedConsent.channels.length !== 0;
              });
  };
  var cnfModalConfirmCb = function (param) {
    Curry._1(updateCnfModalState, (function (param) {
            return false;
          }));
    var consents = getUpdatedConsents(undefined);
    console.log(consents);
    var match = consents.length;
    if (match !== 0) {
      return CustomerApiHandler.UpdateCustomerConsents.execute({
                  uuid: uuid,
                  consents: consents
                }, country, (function (data) {
                    Curry._1(closeCustomerInfoSidebar, undefined);
                    return Curry._1(openSnackbar, {
                                TAG: /* Success */0,
                                _0: data.message
                              });
                  }), (function (error) {
                    return Curry._1(openSnackbar, {
                                TAG: /* Error */1,
                                _0: ErrorUtils$Catalyst.resolveError(error)
                              });
                  }));
    } else {
      return Curry._1(openSnackbar, {
                  TAG: /* Error */1,
                  _0: "Please upadte any of the value"
                });
    }
  };
  var cnfModalCancelCb = function (param) {
    return Curry._1(updateCnfModalState, (function (param) {
                  return false;
                }));
  };
  return React.createElement("div", {
              className: "c-notification-settings-form-container"
            }, React.createElement("div", {
                  className: "form"
                }, $$Array.map((function (config) {
                        return React.createElement(Column$Catalyst.make, {
                                    children: null,
                                    className: "notification-setting"
                                  }, React.createElement("div", {
                                        className: "title"
                                      }, config.title), React.createElement("div", {
                                        className: "description"
                                      }, config.message), config.compulsory.length !== 0 ? React.createElement(Row$Catalyst.make, {
                                          children: null,
                                          className: "compulsory consent"
                                        }, React.createElement("div", undefined, $$Array.map((function (consent) {
                                                    return React.createElement(React.Fragment, undefined, React.createElement("span", undefined, consent.title), React.createElement("span", undefined, ", "));
                                                  }), config.compulsory)), React.createElement(Switch$Catalyst.make, {
                                              checked: true,
                                              on_change: (function (_event) {
                                                  
                                                }),
                                              disabled: true,
                                              switch_color: /* Primary */1
                                            })) : null, $$Array.map((function (consent) {
                                          var form = useForm({
                                                config_id: consent.config_id,
                                                enabled: consent.enabled
                                              }, (function (param, param$1) {
                                                  
                                                }));
                                          consents_input.push(form.input);
                                          return React.createElement(Row$Catalyst.make, {
                                                      children: null,
                                                      className: "optional consent"
                                                    }, React.createElement("div", undefined, consent.title), React.createElement(Switch$Catalyst.make, {
                                                          checked: form.input.enabled,
                                                          on_change: (function (param) {
                                                              Curry._1(setIsConsentUpdated, (function (param) {
                                                                      return true;
                                                                    }));
                                                              var value = !form.input.enabled;
                                                              return Curry._2(form.updateEnabled, (function (input, param) {
                                                                            return {
                                                                                    config_id: input.config_id,
                                                                                    enabled: value
                                                                                  };
                                                                          }), value);
                                                            }),
                                                          switch_color: /* Primary */1
                                                        }));
                                        }), config.optional));
                      }), customer_consents)), React.createElement("div", {
                  className: "footer"
                }, React.createElement(Button$Catalyst.make, {
                      text: "Save Changes",
                      cb: (function (_event) {
                          return Curry._1(updateCnfModalState, (function (param) {
                                        return true;
                                      }));
                        }),
                      className: "submit-btn",
                      disabled: !isConsentUpdated
                    }), React.createElement(ConfirmationModal.make, {
                      title: "Confirm Submit?",
                      isOpen: match$1[0],
                      onConfirmCb: cnfModalConfirmCb,
                      onCancelCb: cnfModalCancelCb,
                      confirm_button_title: "Submit",
                      cancel_button_title: "Cancel",
                      children: React.createElement("div", undefined, "You are about to make changes to the Customer Information. Are you sure you wish to continue?")
                    })));
}

var make = NotificationSettingsCmp;

export {
  Form ,
  make ,
  
}
/* react Not a pure module */
